import { useQuery } from "@tanstack/react-query";
import { useT } from "@/i18n";
import { fetchOrdersFor } from "@/services/stock";

// His order hint (`ORDERS_BY_SKU` / `ORDERS_BY_PID`): which supplier orders of this warehouse's jobs carry
// the product — "Order: #13651 Eglo (Client)" — on the recognition result and the piece's detail.
export default function OrderHint({ productId, sku, warehouseId }: { productId: number | null; sku?: string | null; warehouseId?: number | null }) {
  const { t } = useT();
  const q = useQuery({
    queryKey: ["orders-for", productId, sku, warehouseId], queryFn: () => fetchOrdersFor(productId, sku ?? null, warehouseId),
    enabled: !!productId || !!sku, staleTime: 5 * 60_000,
  });
  const orders = q.data?.orders ?? [];
  if (!orders.length) return null;
  return (
    <p className="mt-1 text-xs text-slate-600">
      {t("stock.orderHint")} : {orders.map((o, i) => (
        <span key={o.order_id ?? i}>{i > 0 && " · "}<span className="font-mono">#{o.order_id}</span> {o.supplier ?? ""}{o.client ? ` (${o.client})` : ""}</span>
      ))}
    </p>
  );
}
